<script>
  import {getContext} from 'svelte';
  import LeaderGeneralForm from '../forms/leader.general';
  import SectionNav from '../../../../components/navigation/section';
  import {addNotification, ICONS} from '../../../../utils/notifications.store';
  import {UPDATE_LEADER, ADD_LEADER} from '../../../../graphql/leaders';
  export let value;

  const client = getContext('apollo');
  const history = getContext('history');

  async function save() {
    const input = {
      firstName: value.firstName,
      lastName: value.lastName,
      email: value.email,
      phone: value.phone,
      bio: value.bio,
      avatar: value.avatar
    }

    if(value.id) {
      input.id = value.id;
    }

    const variables = {
      input
    }

    try {
      addNotification({ icon: ICONS.LOADING, message:`Saving ${value.firstName}`});
      const response = await client.mutate({mutation: value.id ? UPDATE_LEADER :  ADD_LEADER, variables});
      addNotification({ time: 3000, message:`Successfully Saved ${value.firstName}`, icon: ICONS.SUCCESS});

      if(!value.id) {
        value.id = response.data.addLeader.id
        history.push(`/leaders/view/${response.data.addLeader.id}`);
      }

    } catch (e) {
      addNotification({message: `Error Saving ${value.firstName}`, icon: ICONS.ERROR})
    }
    
  }

</script>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-9">
    <LeaderGeneralForm bind:value={value} />
  </div>
  <div class="cell small-12 medium-3">
    <SectionNav>
      <div on:click={save} class="save">
        {#if value.id}SAVE LEADER{/if}
        {#if !value.id}ADD LEADER{/if}
      </div>
    </SectionNav>
  </div>
</div>